import type { AudioPlayerMenuAction } from "../../types/audio-player";

import { AudioPlayerMenuIcon } from "./AudioPlayerMenuIcon";

type AudioPlayerMenuItemProps = {
  action: AudioPlayerMenuAction;
  itemRef: (element: HTMLAnchorElement | HTMLButtonElement | null) => void;
  onSelect: (action: AudioPlayerMenuAction) => void;
};

const MENU_ITEM_CLASS_NAME =
  "group flex h-10 w-full items-center gap-2 rounded-lg px-2 py-2 text-left font-medium text-base leading-6 outline-none hover:bg-[#dcefd2] hover:text-[#2c4f26] focus-visible:bg-[#dcefd2] focus-visible:text-[#2c4f26] focus-visible:ring-2 focus-visible:ring-[#f6ffe3]";

function AudioPlayerMenuItem({
  action,
  itemRef,
  onSelect,
}: AudioPlayerMenuItemProps) {
  const ariaLabel = action.href
    ? `${action.label} (opens in a new tab)`
    : action.label;

  if (action.href) {
    return (
      <a
        aria-label={ariaLabel}
        className={MENU_ITEM_CLASS_NAME}
        href={action.href}
        onClick={() => onSelect(action)}
        ref={itemRef}
        rel="noreferrer"
        role="menuitem"
        target="_blank"
      >
        <AudioPlayerMenuIcon icon={action.icon} />
        <span>{action.label}</span>
      </a>
    );
  }

  return (
    <button
      aria-label={ariaLabel}
      className={MENU_ITEM_CLASS_NAME}
      onClick={() => onSelect(action)}
      ref={itemRef}
      role="menuitem"
      type="button"
    >
      <AudioPlayerMenuIcon icon={action.icon} />
      <span>{action.label}</span>
    </button>
  );
}

export { AudioPlayerMenuItem };
